import { render, staticRenderFns } from "./CadDadosEnderecoEntrega.vue?vue&type=template&id=6b3fe55b&"
import script from "./CadDadosEnderecoEntrega.vue?vue&type=script&lang=js&"
export * from "./CadDadosEnderecoEntrega.vue?vue&type=script&lang=js&"
import style0 from "./CadDadosEnderecoEntrega.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CadDadosEnderecoEntrega.vue"
export default component.exports